import { MODULE_TYPES } from 'constants/common'
import MailTemplateTypes from 'store/actionTypes/mailTemplate'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  filter: {
    [MODULE_TYPES.CIXI_CENTER]: {},
    [MODULE_TYPES.SHOWCASE_WEB]: {},
    [MODULE_TYPES.MOBILE_APP]: {}
  },
  tokens: []
}

const mailTemplate = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case MailTemplateTypes.GET_MAIL_TEMPLATES_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case MailTemplateTypes.GET_MAIL_TEMPLATE_DETAIL_SUCCESS:
      return { ...state, current: payload }
    case MailTemplateTypes.GET_MAIL_TEMPLATE_TOKENS_SUCCESS:
      return { ...state, tokens: payload }
    case MailTemplateTypes.UPDATE_FILTER_MAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        filter: {
          ...state.filter,
          [payload?.moduleName]: payload?.data
        }
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default mailTemplate
